import React from "react";
import styled from "styled-components";

const CommonCellButton = ({ children, styles, hoverBlock }) => {
  return (
    <ButtonWrap $hoverBlock={hoverBlock} style={styles}>
      {children}
    </ButtonWrap>
  );
};

const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 93px;
  height: 24px;
  border-radius: 6px;
  font-size: 12px;
  background-color: #fff;
  border: 1px solid #d1d1d1;
  ${({ $hoverBlock }) =>
    !$hoverBlock && "cursor: pointer;&:hover { opacity: 0.8; }"}
`;

export default CommonCellButton;
